import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { styled } from 'styletron-react';

import backIcon from 'presentation/assets/icons/png/3x/icn-arrow-left-big@3x.png';
import Icon, { getPixelSize, ICONSIZE } from 'presentation/components/Icon';
import { md } from 'presentation/theme/mediaQueries';

const IconCol = styled(Col, {
  paddingTop: '4px',
  [md]: { paddingTop: '24px' }
});

interface Props {
  onPrevClick?: () => void;
  title: string;
}

const TitleWithPrevPageLink: React.FC<Props> = ({ title, onPrevClick }) => {
  return (
    <Row>
      {!!onPrevClick && (
        <IconCol xs="auto">
          <div
            style={{
              width: getPixelSize(ICONSIZE.medium),
              height: getPixelSize(ICONSIZE.medium)
            }}
          >
            <Icon
              iconSrc={backIcon}
              handleClick={onPrevClick}
              size={ICONSIZE.medium}
              alt="back button"
              additionalTestId="prev"
              className={!!onPrevClick ? 'd-block' : 'd-none'}
              aria-label="Zurück zur vorherigen Seite"
            />
          </div>
        </IconCol>
      )}

      <Col xs className={`px-sm-3${!!onPrevClick ? ' px-0' : ''}`}>
        <div className="py-0 py-md-3" data-gi="page-title-element">
          <h1 className="visually-hidden">{title}</h1>
          <h3 className="m-auto text-center text-break">{title}</h3>
        </div>
      </Col>

      {!!onPrevClick && (
        <IconCol xs="auto">
          <div
            style={{
              width: getPixelSize(ICONSIZE.medium),
              height: getPixelSize(ICONSIZE.medium)
            }}
          ></div>
        </IconCol>
      )}
    </Row>
  );
};

export default TitleWithPrevPageLink;
